var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"small"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t('components_switchButton.geng_duo_shai_xuan'))+"\n  "),(_vm.open)?_c('i',{staticClass:"el-icon-arrow-up el-icon--right"}):_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }